"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  script: {
    fontFamily: 'lcScript',
    textTransform: 'none',
    display: 'inline-block'
  },
  heading: {
    color: 'black',
    fontSize: 22,
    fontFamily: 'mrEaves',
    fontWeight: 'normal'
  },
  headline: {
    textTransform: 'uppercase',
    lineHeight: '0.8em',
    color: 'black',
    fontSize: 22,
    fontFamily: 'mrEaves',
    fontWeight: 'bold'
  }
};
exports.default = _default;